import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { MessageDialogComponent } from './message-dialog.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [MessageDialogComponent],
    declarations: [MessageDialogComponent],
})
export class MessageDialogModule {}
